import { useSelectUser } from "@shared/utils/hooks/misc";
import { HEDGING_BOTS_FEATURE_FLAG } from "@shared/common/constants";
import useQuery from "utils/hooks/useQuery";
import { BotType } from "@shared/types";

export const TRADING_INTENTS = [
  "signals",
  "grid",
  "tradingview",
  "dca",
  "hedging",
] as const;
export type TradingIntent = (typeof TRADING_INTENTS)[number];
export const PRACTICE_SYMBOLS = [
  "BTC/USDT",
  "BTC/USDC",
  "BTC/USD",
  "ETH/USDT",
  "ETH/USDC",
  "ETH/USD",
];
export const INTENT_BOT_TYPES: Record<TradingIntent, BotType> = {
  signals: BotType.SIGNAL,
  grid: BotType.GRID,
  tradingview: BotType.TRADING_VIEW,
  dca: BotType.ASAP,
  hedging: BotType.HEDGING,
};
export const getTradingIntent = (
  query: URLSearchParams
): TradingIntent | undefined => {
  if (query.get("groupID")) return "signals";
  if (query.get("botUUID")) return "dca";
  const method = query.get("method");
  return TRADING_INTENTS.find((intent) => intent === method);
};
export const getPracticeExchange = (intent?: TradingIntent): string =>
  intent === "hedging" || intent === "signals" ? "Binance Futures" : "Binance";

export const useTradingIntent = () => {
  const user = useSelectUser();
  const query = useQuery();
  const requestedIntent = getTradingIntent(query);
  const availableIntents = TRADING_INTENTS.filter(
    (intent) =>
      intent !== "hedging" || user?.hasFeatureFlag(HEDGING_BOTS_FEATURE_FLAG)
  );
  const unavailable =
    !!user && !!requestedIntent && !availableIntents.includes(requestedIntent);
  return {
    intent: unavailable ? undefined : requestedIntent,
    availableIntents,
    unavailable,
  };
};
